// removed by extract-text-webpack-plugin
module.exports = {"arrow":"qempo_Arrow_arrow-2TTMmiz","visible":"qempo_Arrow_visible-9RfpQa4"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/Arrow/Arrow.scss
// module id = 1170
// module chunks = 0